var angular = require('angular');
var ngRoute = require('angular-route');
var ngSanitize = require('angular-sanitize');
var Raven = require('raven-js');
var ngRaven = require('raven-js/plugins/angular').moduleName;
require('angular-pickadate/src/angular-pickadate');

require('css/style');
require('images/favicon.ico');

if (process.env.SENTRY_DSN === '') {
  // Never bother sending data to sentry
  Raven.setShouldSendCallback(function() { return false });
  // Allow Raven.install() to succeed
  Raven.isSetup = function() { return true; }
}

Raven
  .config(process.env.SENTRY_DSN, {
    release: '1.173.0'
  })
  .addPlugin(require('raven-js/plugins/angular'), angular)
  .install();

Raven.setTagsContext({
  environment: process.env.CONFIG
});


angular.module('app', [ngRaven, ngRoute, ngSanitize, 'pickadate'])
  .filter('moment', require('js/filters/moment'))
  .filter('duration', require('js/filters/duration'))
  .filter('durationSeconds', require('js/filters/durationSeconds'))
  .filter('weightInKg', require('js/filters/weightInKg'))
  .filter('activeRoutePlans', require('js/filters/activeRoutePlans'))
  .filter('fleetCustomers', require('js/filters/fleetCustomers'))
  .filter('fleetRoutes', require('js/filters/fleetRoutes'))
  .filter('receivedSms', require('js/filters/receivedSms'))
  .directive('calendar', require('js/directives/calendar'))
  .directive('tooltip', require('js/directives/tooltip'))
  .directive('spinner', require('js/directives/spinner'))
  .directive('initials', require('js/directives/initials'))
  .directive('routeName', require('js/directives/routeName'))
  .directive('fileOnChange', require('js/directives/fileOnChange'))
  .directive('planCustomersTabs', require('js/directives/planCustomersTabs'))
  .directive('map', require('js/directives/map'))
  .directive('mapCoordinates', require('js/directives/mapCoordinates'))
  .directive('moveStopLocation', require('js/directives/moveStopLocation'))
  .directive('addressHelper', require('js/directives/addressHelper'))
  .directive('page', require('js/directives/page'))
  .directive('pageHeader', require('js/directives/pageHeader'))
  .directive('pageTitle', require('js/directives/pageTitle'))
  .directive('distributionHeader', require('js/directives/distributionHeader'))
  .directive('print', require('js/directives/print'))
  .directive('deliveryCount', require('js/directives/deliveryCount'))
  .directive('statusDeliveries', require('js/directives/statusDeliveries'))
  .directive('imageModal', require('js/directives/imageModal'))
  .directive('animateOnChange', require('js/directives/animateOnChange'))
  .directive('sortable', require('js/directives/sortable'))
  .directive('planRoutesStats', require('js/directives/planRoutesStats'))
  .directive('fleetDashboardStats', require('js/directives/fleetDashboardStats'))
  .directive('downtimeWarnings', require('js/directives/downtimeWarnings'))
  .directive('progressBar', require('js/directives/progressBar'))
  .service('http', require('js/services/http'))
  .service('serverError', require('js/services/serverError'))
  .service('pusher', require('js/services/pusher'))
  .service('load', require('js/services/load'))
  .service('login', require('js/services/login'))
  .service('router', require('js/services/router'))
  .service('modal', require('js/services/modal'))
  .service('storage', require('js/services/storage'))
  .service('clock', require('js/services/clock'))
  .service('editRoute', require('js/services/editRoute'))
  .service('editCustomer', require('js/services/editCustomer'))
  .service('loadScript', require('js/services/loadScript'))
  .service('editRoutePlan', require('js/services/editRoutePlan'))
  .controller('indexCtrl', require('js/controllers/indexCtrl'))
  .controller('commonCtrl', require('js/controllers/commonCtrl'))
  .controller('settingsCtrl', require('js/controllers/settingsCtrl'))
  .controller('planCtrl', require('js/controllers/planCtrl'))
  .controller('distributionCtrl', require('js/controllers/distributionCtrl'))
  .controller('planCustomersCtrl', require('js/controllers/planCustomersCtrl'))
  .controller('planRoutesCtrl', require('js/controllers/planRoutesCtrl'))
  .controller('fleetCtrl', require('js/controllers/fleetCtrl'))
  .controller('driverUsersCtrl', require('js/controllers/driverUsersCtrl'))
  .controller('usersCtrl', require('js/controllers/usersCtrl'))
  .constant('config', require('js/config').constant)
  .config(require('js/config').config)
  .run(require('js/config').run);



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/app.js
 ** module id = 0
 ** module chunks = 1
 **/